import { h, Component } from 'preact';
import cx from 'classnames';
import style from './style.less';
import SimpleVerticalCard from '../../cards/simple-vertical-card';
import CardHeader from '../../pieces/card-header';
import { fetchArticleList } from '../../../lib/data';

import { trackingProvider, TrackingProvider, DIMENSION } from '@cube/track';

/**
 * A grid of cards where each row can have 1-6 items
 * @param {Object}  assets contents for the cards
 * @param {Array}   rowCounts array of integers of the number of items in each row
*/
@trackingProvider({
	[DIMENSION.componentpath]: 'CustomizedGridCluster'
})
export default class CustomizedGridCluster extends Component {

	state = {
		loading: false,
		error: false
	};
	getAssets = (props) => {
		this.setState({
			loading: true,
			error: false
		});

		return fetchArticleList({
			count: props.rowCounts.reduce((a, b) => a + b, 0),
			imageSizes: props.imageRole,
			...props
		})
			.then( res => {
				if (res.articles && res.articles.length > 0) {
					this.setState({
						assets: res.articles,
						loading: false,
						error: false
					});
					return;
				}
				this.setState({
					loading: false,
					error: true
				});
			})
			.catch( error => {
				this.setState({
					loading: false,
					error: true
				});
			});
	};

	createRows = ({ assets, theme, rowCounts, qeId, props }) => {
		// Validate rows.  Must be integer between 1 and 6
		const MIN_ROW = 1;
		const MAX_ROW = 6;
		rowCounts = rowCounts.filter(row => typeof row === 'number' && row >= MIN_ROW && row <= MAX_ROW);

		let rowDivs = [],
			start = 0,
			end = 0;

		for (let currentRow = 0; currentRow < rowCounts.length; currentRow++) {
			end = start + rowCounts[currentRow];

			// if cannot finish line with assets, stop processing
			if (end > assets.length) break;

			rowDivs.push(
				<div class={cx(style.cards, style['columns' + rowCounts[currentRow]])}>
					{ assets.slice(start, end).map((asset, j) => (
						<TrackingProvider {...{
							[DIMENSION.clickindex]: start+j+1
						}}
						>
							<SimpleVerticalCard
								theme={theme}
								asset={asset}
								qeId={qeId + '-' + (start+j)}
								{...props}
							/>
						</TrackingProvider>
					)) }
				</div>
			);
			start = start + rowCounts[currentRow];
		}

		return rowDivs;
	};

	static defaultProps = {
		rowCounts: []
	};

	componentWillMount() {
		if (this.props.assets && this.props.assets.length > 0) {
			this.setState({
				assets: this.props.assets
			});
			return;
		}
		this.getAssets(this.props);
	}

	render({ theme, rowCounts, title, clusterClass, qeId, link, ...props }, { assets, loading, error }) {
		if (error ||
			!assets || assets.length === 0 ||
			!rowCounts || rowCounts.length === 0
		) return null;

		return (
			<div class={cx(style.customizedGridCluster, clusterClass)} qid={qeId}>
				<CardHeader title={title} link={link} qeId={qeId} />
				{ this.createRows( { assets, theme, rowCounts, qeId, props } ) }
			</div>
		);
	}
}
